module.exports = __webpack_public_path__ + "img/logo-medium.94c612fc.svg";